import isEmpty from '../../../../utils/objectchecking/IsEmpty';
import { validate as validateSymbol } from '../tradingPlanFormComponents/FieldComponents/Symbol';

export function mfeRetracementValidation(MFE_RETRACEMENT) {
  if (Number(MFE_RETRACEMENT.activationValue) <= 0)
    return [false, ' Activation Amount must be larger than 0. '];
  if (Number(MFE_RETRACEMENT.retracePct) <= 0)
    return [false, ' Retrace Percentage must be larger than 0. '];
  return [true, ''];
}

export function underlyingPriceExitValidation(UNDERLYING_PRICE_EXIT) {
  const prices = UNDERLYING_PRICE_EXIT.underlyingPricePairs.map(
    (pair) => pair.price
  );
  const pcts = UNDERLYING_PRICE_EXIT.underlyingPricePairs.map((pair) =>
    pair.qtyPct.toString()
  );
  const pricesSet = new Set(prices);
  if (prices.length !== pricesSet.size)
    return [false, 'All prices must be unique.'];
  if (pcts.includes('0'))
    return [false, 'Zero is not a valid quantity percent.'];
  return [true, ''];
}
export function lossLimitValidation(LOSS_LIMIT) {
  if (parseFloat(LOSS_LIMIT.amount) <= 0) {
    return [false, ' loss limit amount is zero. '];
  }
  return [true, ''];
}

export function positionPriceTrailValidation(POSITION_PRICE_TRAIL) {
  if (parseFloat(POSITION_PRICE_TRAIL.amount) <= 0) {
    return [false, ' Trail amount is equal to or less than zero. '];
  }
  return [true, ''];
}

export function candleMagnitudeValidation(CANDLE_MAGNITUDE) {
  const candleDuration = parseInt(CANDLE_MAGNITUDE.candleDuration);
  //  console.log(candleDuration);
  const numberOfPivots = parseInt(CANDLE_MAGNITUDE.numberOfPivots);
  //  console.log(numberOfPivots);
  const qtyPctPerPivot = CANDLE_MAGNITUDE.qtyPctPerPivot;
  // console.log(qtyPctPerPivot);
  const exitInPivotCandle = CANDLE_MAGNITUDE.exitInPivotCandle;
  // console.log(exitInPivotCandle);
  const timeUnit = CANDLE_MAGNITUDE.timeUnit;
  // console.log(timeUnit);
  const usePivotsAsTrails = CANDLE_MAGNITUDE.usePivotsAsTrails;
  // console.log(usePivotsAsTrails);
  const initialStop = CANDLE_MAGNITUDE.initialStop;
  const firstTargetStop = CANDLE_MAGNITUDE.firstTargetStop;
  let validForm = true;
  let message = '';
  if (
    usePivotsAsTrails &&
    (initialStop === 'NONE' || firstTargetStop === 'NONE') &&
    initialStop !== firstTargetStop
  ) {
    validForm = false;
    message +=
      'Either Initial Stop and or First Target Stop is set to NONE, while the other is not set. Set both to NONE, or set the one that is set to NONE to a different option. ';
  }
  if (!candleDuration || isNaN(candleDuration)) {
    validForm = false;
    message += ' Candle Duration not valid. ';
  }
  if (!numberOfPivots || isNaN(numberOfPivots)) {
    if (usePivotsAsTrails) {
      validForm = false;
      message = ' Number of pivots set to 0.';
    }
  }
  if (usePivotsAsTrails) {
    if (
      !qtyPctPerPivot ||
      (qtyPctPerPivot.length == 0 && numberOfPivots == 0)
    ) {
      validForm = false;
      message = ' No targets or pivots given. ';
    }
  }
  if (!qtyPctPerPivot || qtyPctPerPivot.length == 0) {
    if (!usePivotsAsTrails) {
      validForm = false;
      message +=
        ' Use pivots as trail is set to false, but there is no qty per pivot taken. Either check use pivots as trail, in which each magnitude is used a stop, or provide profits to be taken at each magnitude. ';
    }
    for (const index in qtyPctPerPivot) {
      if (isNaN(qtyPctPerPivot[index])) {
        validForm = false;
        message +=
          ' There are values in the qty per pivot array that are not numbers. ';
      }
    }
  }

  if (!timeUnit) {
    validForm = false;
    message = ' No time Unit provided. ';
  }
  if (!exitInPivotCandle) {
    if (usePivotsAsTrails) {
      validForm = false;
      message = ' Exit in pivot candle not provided. ';
    }
  }

  if (
    CANDLE_MAGNITUDE.generateFromAtrWhenNoPivots &&
    CANDLE_MAGNITUDE.pctAtrGenerateAtrWhenNoPivots == 0
  ) {
    validForm = false;
    message = 'Extend Pivots w/ATR cannot be set to 0% ';
  }
  return [validForm, message];
  //usePivotsAsTrails: false,
  //filterInsideCandleMagnitudes: false,
  //timeUnit: 'MINUTES', // MINUTES, HOURS, DAYS, WEEKS, MONTHS, QUARTERS, YEARS
}

export function underlyingPriceTrailValidation(UNDERLYING_PRICE_TRAIL) {
  if (parseFloat(UNDERLYING_PRICE_TRAIL.amount) <= 0) {
    return [
      false,
      'Underlying price trail amount is less than or equal to zero. ',
    ];
  }
  return [true, ''];
}

export function greenToRedCandlesValidation(GREEN_TO_RED_CANDLES) {
  let validForm = true;
  let message = '';
  if (parseFloat(GREEN_TO_RED_CANDLES.retracePct) <= 0) {
    validForm = false;
    message +=
      ' green to red candles retracePct direction pct isequal to or less than zero. ';
  }
  if (parseInt(GREEN_TO_RED_CANDLES.candleDuration) <= 0) {
    validForm = false;
    message +=
      ' green to red candles candle duration is equal to or less than zero. ';
  }
  return [validForm, message];
}

export function greenToRedPositionsValidation(GREEN_TO_RED_POSITIONS) {
  let validForm = true;
  let message = '';
  if (parseFloat(GREEN_TO_RED_POSITIONS.inRightDirectionPct) === 0) {
    validForm = false;
    message += ' green to red positions right direction pct is zero. ';
  }
  if (
    parseFloat(GREEN_TO_RED_POSITIONS.inRightDirectionPct) <=
    parseFloat(GREEN_TO_RED_POSITIONS.retracePct)
  ) {
    validForm = false;
    message += ' green to red positions right direction less than retrace. ';
  }
  return [validForm, message];
}

export function candleTrailValidation(CANDLE_TRAIL) {
  if (parseInt(CANDLE_TRAIL.candleDuration) <= 0) {
    return [false, ' Candle trail duration is equal to or less than 0. '];
  }
  return [true, ''];
}
export function atrTrailValidation(ATR_TRAIL) {
  if (parseFloat(ATR_TRAIL.pctOfAtr) === 0) {
    return [false, ' atr trail pct of atr is equal to 0 '];
  }
  return [true, ''];
}
export function breakPriceValidation(BREAK_PRICE) {
  if (BREAK_PRICE.prices === null || BREAK_PRICE.prices.length === 0) {
    return [false, ' Zero break prices prices provided. '];
  }
  return [true, ''];
}

export function positionBreakPriceValidation(POSITION_BREAK_PRICE) {
  if (
    POSITION_BREAK_PRICE.prices === null ||
    POSITION_BREAK_PRICE.prices.length === 0
  ) {
    return [false, ' Zero break prices prices provided. '];
  }
  return [true, ''];
}

export function grabCentsValidation(gc) {
  let validForm = true;
  let message = '';
  if (gc.centsPerLevel === undefined || gc.centsPerLevel === null) {
    validForm = false;
    message += ' grab cents $ per level is zero. ';
  }
  if (!gc.takeProfitMode) {
    validForm = false;
    message += ' take profit mode not set for grab cents. ';
  }
  const notQtyPerLevel =
    gc.quantityPerLevel === undefined || gc.quantityPerLevel === null;
  const notPctPerLevel =
    gc.percentagePerLevel === undefined || gc.percentagePerLevel === null;

  if (notPctPerLevel && notQtyPerLevel) {
    validForm = false;
    message += ' grab cents $ per level qtys are zero. ';
  } else {
    if (!notPctPerLevel) {
      if (gc.centsPerLevel?.length !== gc.percentagePerLevel?.length) {
        validForm = false;
        message +=
          ' grab cents $ per level qty and grab cents amounts are not equal. ';
      }
    }
    if (!notQtyPerLevel) {
      if (gc.centsPerLevel?.length !== gc.quantityPerLevel?.length) {
        validForm = false;
        message +=
          ' grab cents $ per level qty and grab cents amounts are not equal. ';
      }
    }
    if (notPctPerLevel) {
      gc.quantityPerLevel.forEach((qty) => {
        if (qty < 1) {
          validForm = false;
          message += ' grab cents qty per level less than 1. ';
        }
      });
    }
    if (notQtyPerLevel) {
      gc.percentagePerLevel.forEach((pct) => {
        if (pct > 1) {
          validForm = false;
          message += ' grab cents pct per level more than 1. ';
        }
      });
    }
  }
  const gcValuesList = [];
  for (let i = 0; i < gc.centsPerLevel.length; i++) {
    const centsLevel = gc.centsPerLevel[i];
    const qtyLevel = notQtyPerLevel
      ? gc.percentagePerLevel[i]
      : gc.quantityPerLevel[i];
    gcValuesList.push(centsLevel + '-' + qtyLevel);
  }
  const gcValuesSet = new Set(gcValuesList);
  if (gcValuesSet.size != gcValuesList.length) {
    validForm = false;
    message +=
      ' there are take profit and qty levels that are the same as one another ';
  }
  const trail = notPctPerLevel ? gc.trailQuantity : gc.trailPercent;
  if (parseInt(trail) !== 0 && parseFloat(gc.trailAmount) <= 0) {
    validForm = false;
    message +=
      ' grab cents trail qty is not zero but the trail amount is equal to or less than zero. ';
  }
  return [validForm, message];
}

export function ratchetBracketValidation(rb) {
  let validForm = true;
  let message = '';
  if (rb.mode === undefined || rb.mode === '') {
    validForm = false;
    message += ' no mode selected. ';
  }
  if (rb.mode === 'EQUAL_INTERVAL') {
    if (
      rb.targetPerBracket === undefined ||
      parseFloat(rb.targetPerBracket) <= 0 ||
      isNaN(rb.targetPerBracket)
    ) {
      validForm = false;
      message +=
        ' Ratchet Bracket target per bracket is equal to or less than zero. ';
    }
    if (
      rb.stopPerBracket === undefined ||
      parseFloat(rb.stopPerBracket) <= 0 ||
      isNaN(rb.stopPerBracket)
    ) {
      validForm = false;
      message +=
        ' Ratchet Bracket stop per bracket is equal to or less than zero. ';
    }
    if (
      rb.qtyBasisValuePerBracket === undefined ||
      parseFloat(rb.qtyBasisValuePerBracket) <= 0 ||
      isNaN(rb.qtyBasisValuePerBracket)
    ) {
      //   console.log("reached here: " + rb.qtyBasisValuePerBracket, rb.quantityBasis);
      if (rb.qtyBasis === 'PERCENT' || rb.qtyBasis === 'PROFIT') {
        if (rb.trailQtyBasisValue !== 1) {
          //ie 100%
          validForm = false;
          message +=
            ' Ratchet Bracket qtyBasisValue per bracket is equal to or less than zero and trail is not 100%. ';
        }
      }
    }
  }
  return [validForm, message];
}
export function preserveProfitValidation(details) {
  if (Number(details.activationProfitAmount) < Number(details.amount)) {
    return [false, 'Activation amount is smaller than preserve amount.'];
  } else if (details.amount <= 0) {
    return [false, 'Preserve amount is less than or equal to zero.'];
  } else return [true, ''];
}

export const dataValidation = (
  data,
  symbolsRemaining,
  finishedRenderingOptionChain
) => {
  let validForm = true;
  let message = '';
  // console.log("finishedRenderingChain: " + finishedRenderingOptionChain);
  if (data.instrument === 'option') {
    if (data.symbol.includes(',')) {
      validForm = false;
      message += ' cannot do multi-symbol trade plan on options...';
      return [validForm, message];
    } else if (!finishedRenderingOptionChain) {
      validForm = false;
      message += ' still fetching option chain...';
      return [validForm, message];
    }
  }
  if (/\d/.test(data.symbol)) {
    validForm = false;
    message += 'symbol cannot contain a number';
  }
  if (!validateSymbol(data.symbol)) {
    validForm = false;
    message += 'invalid symbol: ' + data.symbol;
  }

  if (data.dataSource === 'LIVE' && data.startPeriod === 'open') {
    if (data.startHour < 9) {
      validForm = false;
      message += 'trade plan before market opens.';
    } else if (data.startHour === 9 && data.startMin < 30) {
      validForm = false;
      message += 'trade plan before market opens.';
    } else if (data.startHour >= 16) {
      validForm = false;
      message += 'trade plan after market closes.';
    }
  }
  if (data.startPeriod && data.dataSource === 'LIVE') {
    switch (data.startPeriod) {
      case 'open':
        if (
          data.startHour < 9 ||
          (data.startPeriod === 9 && data.startMin < 30)
        ) {
          validForm = false;
          message += 'trade plan before market opens.';
        }
        if (data.startHour > 16) {
          validForm = false;
          message += 'trade plan after market closes.';
        }
        break;
      case 'premarket':
        if (
          data.startHour > 9 ||
          (data.startPeriod === 9 && data.startMin > 30)
        ) {
          validForm = false;
          message += ' Pre market trade plan set for after market opens. ';
        }
        if (data.startHour < 8) {
          validForm = false;
          message +=
            ' Pre market trade plan can only be activated after 8 am eastern. ';
        }
        break;
      case 'postmarket':
        if (data.startHour < 16) {
          validForm = false;
          message +=
            ' Post market trade plan can only be activated after 4pm eastern. ';
        }
        if (data.startHour > 17) {
          validForm = false;
          message +=
            ' Post market trade plan can only be activated until 5pm eastern. ';
        }
        break;
    }
  }
  if (data.startPeriod) {
    if (data.startPeriod === 'postmarket' || data.startPeriod === 'premarket') {
      if (data.instrument === 'option') {
        validForm = false;
        message += ' Cannot trade options outside of regular hours. ';
      }
      const entries = data.entryTactics;
      const setup = data.setup;
      const exits = data.exitTactics;
      const setupFilters = data.setupFilters;
      let usingCandleExit = false;
      let candleMsg =
        'do not support candle tactics for trading outside of regular hours: ';
      console.log(setup);
      if (setup === 'CANDLE_TRIGGER') {
        usingCandleExit = true;
        candleMsg += '(candle trigger), ';
      }
      if (setup === 'CONVICTION_CANDLE') {
        usingCandleExit = true;
        candleMsg += '(conviction candle), ';
      }
      if (setup === 'BOUNCE_EMA') {
        usingCandleExit = true;
        candleMsg += '(bounce ema), ';
      }
      if (setup === 'BREAK_EMA') {
        usingCandleExit = true;
        candleMsg += '(break ema), ';
      }
      if (setup === 'FLAG') {
        usingCandleExit = true;
        candleMsg += '(flag), ';
      }
      if (setup === 'BREAK_CANDLE_TYPE') {
        usingCandleExit = true;
        candleMsg += '(break candle type), ';
      }
      if (setup === 'CANDLE_PATTERN') {
        usingCandleExit = true;
        candleMsg += '(candle pattern), ';
      }
      if (setup === 'ORB') {
        usingCandleExit = true;
        candleMsg += '(orb), ';
      }
      if (entries['CANDLE_BREAK']) {
        usingCandleExit = true;
        candleMsg += '(candle break), ';
      }
      if (setupFilters) {
        if (setupFilters['PRICE_INTERSECTS_FIRST_CANDLE']) {
          usingCandleExit = true;
          candleMsg += '(price intersects first candle), ';
        }
        if (setupFilters['EMA_INTERSECTS_FIRST_CANDLE']) {
          usingCandleExit = true;
          candleMsg += '(ema intersects first candle), ';
        }
        if (setupFilters['FTFC']) {
          usingCandleExit = true;
          candleMsg += '(FTFC), ';
        }
      }
      if (exits['CANDLE_MAGNITUDE']) {
        usingCandleExit = true;
        candleMsg += '(candle magnitude), ';
      }
      if (exits['CANDLE_TRAIL']) {
        usingCandleExit = true;
        candleMsg += '(candle trail), ';
      }
      if (exits['GREEN_TO_RED_CANDLES']) {
        usingCandleExit = true;
        candleMsg += '(green to red candles), ';
      }
      if (usingCandleExit) {
        validForm = false;
        message += candleMsg;
      }
    }
  }

  if (data.restartSystemOncePositionHasFlattened) {
    /* if (data.persistTradePlanOnFailedFiltersOrValidation) {
          validForm = false;
          message +=
            ' If repeating is checked, persist trade plan should not be used. ';
        } */
    if (data.setup !== 'BREAK_CANDLE_TYPE' && data.setup !== 'CANDLE_PATTERN') {
      if (!data.restartSettings.deactivateOnRestart) {
        validForm = false;
        message +=
          ' If the setup is not break candle type and candle pattern setup, repeating mode is only allowed if deactivate on restart is checked.';
      }
    }
    if (data.setup === 'AD_HOC') {
      if (
        data.entryTactics['MARKET_ORDER'] !== undefined ||
        data.entryTactics['LIMIT_ORDER'] !== undefined
      ) {
        validForm = false;
        message +=
          'restart system on flattened position+adhoc marketOrder/limitOrder will result in a never ending loop of positions.';
      }
    }
    const restartSettings = data.restartSettings;
    if (restartSettings.isMaxMinutesInTradePlan) {
      if (restartSettings.maxMinutesInTradePlan === 0) {
        validForm = false;
        message += 'Max minutes in trade plan set to 0.';
      }
    }
    if (restartSettings.isMaxRestartAttempts) {
      if (restartSettings.maxRestartAttempts === 0) {
        validForm = false;
        message += 'Max restart attempts set to 0.';
      }
    }
    if (restartSettings.isNumberOfTrades) {
      if (restartSettings.numberOfTrades === 0) {
        validForm = false;
        message += 'number of trades set to 0.';
      }
    }
  }
  if (data.symbol === '') {
    validForm = false;
    message += 'No symbol.';
  }
  if (!data.goLong && !data.goShort) {
    validForm = false;
    message += 'long and/or short must be selected. ';
  } else if (data.goLong === data.goShort) {
    if (
      data.setup !== 'CONVICTION_CANDLE' &&
      data.setup !== 'AD_HOC' &&
      data.setup !== 'CANDLE_TRIGGER' &&
      data.setup !== 'CANDLE_PATTERN' &&
      data.setup !== 'FTFC' &&
      data.setup !== 'ORB' &&
      data.setup !== 'FLAG'
    ) {
      // this is a prob. check not always happening
      validForm = false;
      message +=
        'go long and go short can only be the same if setup is conviction candle, adhoc, flag, ORB, or candle trigger';
    } else if (data.setup === 'AD_HOC') {
      if (
        data.entryTactics.MARKET_ORDER !== undefined ||
        data.entryTactics.LIMIT_ORDER !== undefined
      ) {
        message += 'cannot go long and short on market or limit order.';
      }
    }
  }
  //if (data.setup === "AD_HOC") {
  //if (data.setupFilters !== undefined) {
  //  validForm = false;
  //    message = "cannot have setup filters on ad hoc.";
  //  }
  //}
  if (data.setup === 'CANDLE_PATTERN') {
    if (
      data.entryTactics.CANDLE_BREAK &&
      !data.entryTactics.CANDLE_BREAK.waitUntilCurrentCandleCloses
    ) {
      validForm = false;
      message +=
        'dont wait until current candle closes on candle break entry with candle pattern setup. ';
    }
    const patterns = data.setupDetails['CANDLE_PATTERN'].pattern;
    if (isEmpty(patterns)) {
      validForm = false;
      message += 'no patterns. ';
    }
    for (const i in patterns) {
      const pattern = patterns[i];
      for (const index in pattern) {
        const sequence = pattern[index];
        if (
          parseInt(index) !== pattern.length - 1 &&
          sequence.candleSequence === 'BREAK_CANDLE'
        ) {
          validForm = false;
          message += '"2" can only be used on last sequence';
        }
        if (
          parseInt(index) !== pattern.length - 1 &&
          sequence.candleSequence === 'OUTSIDE_CANDLE_UP'
        ) {
          validForm = false;
          message += '"3u" can only be used on last sequence';
        }
        if (
          parseInt(index) !== pattern.length - 1 &&
          sequence.candleSequence === 'OUTSIDE_CANDLE_DOWN'
        ) {
          validForm = false;
          message += '"3d" can only be used on last sequence';
        }
      }
      const lastSequence = pattern[pattern.length - 1];
      if (lastSequence === undefined) {
        validForm = false;
        message += 'cannot find last sequence. ';
      }
      if (
        lastSequence.candleSequence === 'INSIDE_CANDLE' ||
        lastSequence.candleSequence === 'FAIL_TO_BREAK_LOW' ||
        lastSequence.candleSequence === 'FAIL_TO_BREAK_HIGH'
      ) {
        validForm = false;
        message += 'Last sequence must be a break low or high. ';
      }
      if (data.goLong && !data.goShort) {
        if (
          lastSequence.candleSequence === 'BREAK_LOW' ||
          lastSequence.candleSequence === 'OUTSIDE_CANDLE_DOWN'
        ) {
          validForm = false;
          message += 'Enter long on a break low candle sequence. ';
        }
      } else if (!data.goLong && data.goShort) {
        if (
          lastSequence.candleSequence === 'BREAK_HIGH' ||
          lastSequence.candleSequence === 'OUTSIDE_CANDLE_UP'
        ) {
          validForm = false;
          message += 'Enter short on a break high candle sequence. ';
        }
      }
    }
  }
  if (parseInt(symbolsRemaining.current) < 0) {
    validForm = false;
    message += 'trade plan will result in too many symbols.';
  }
  if (isEmpty(data.entryTactics)) {
    validForm = false;
    message += ' No EntryTactics. ';
  } else {
    if (data.entryTactics.MARKET_ORDER !== undefined) {
      if (data.entryTactics.MARKET_ORDER.quantityBasisValue === 0) {
        validForm = false;
        message += ' market order qty basis value is zero. ';
      }
    }
    if (data.entryTactics.CANDLE_BREAK !== undefined) {
      if (data.entryTactics.CANDLE_BREAK.quantityBasisValue === 0) {
        validForm = false;
        message += ' candle break qty basis value is zero. ';
      }
      if (data.entryTactics.CANDLE_BREAK.candleDuration === 0) {
        validForm = false;
        message += ' candle break candle duration is zero. ';
      }
    }
    if (data.entryTactics.LIMIT_ORDER !== undefined) {
      if (data.entryTactics.LIMIT_ORDER.quantityBasisValue === 0) {
        validForm = false;
        message += ' limit order qty basis value is zero. ';
      }
    }
  }
  if (isEmpty(data.exitTactics)) {
    validForm = false;
    message += 'No ExitTactics. ';
  } else {
    if (data.exitTactics.LOSS_LIMIT !== undefined) {
      const [valid, msg] = lossLimitValidation(data.exitTactics.LOSS_LIMIT);
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
    if (data.exitTactics.POSITION_PRICE_TRAIL !== undefined) {
      const [valid, msg] = positionPriceTrailValidation(
        data.exitTactics.POSITION_PRICE_TRAIL
      );
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
    if (data.exitTactics.GREEN_TO_RED_CANDLES !== undefined) {
      const [valid, msg] = greenToRedCandlesValidation(
        data.exitTactics.GREEN_TO_RED_CANDLES
      );
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
    if (data.exitTactics.GREEN_TO_RED_POSITIONS !== undefined) {
      const [valid, msg] = greenToRedPositionsValidation(
        data.exitTactics.GREEN_TO_RED_POSITIONS
      );
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
    if (data.exitTactics.UNDERLYING_PRICE_TRAIL !== undefined) {
      const [valid, msg] = underlyingPriceTrailValidation(
        data.exitTactics.UNDERLYING_PRICE_TRAIL
      );
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
    if (data.exitTactics.CANDLE_MAGNITUDE !== undefined) {
      const [valid, msg] = candleMagnitudeValidation(
        data.exitTactics.CANDLE_MAGNITUDE
      );
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
    if (data.exitTactics.CANDLE_TRAIL !== undefined) {
      const [valid, msg] = candleTrailValidation(data.exitTactics.CANDLE_TRAIL);
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
    if (data.exitTactics.BREAK_PRICE !== undefined) {
      const [valid, msg] = breakPriceValidation(data.exitTactics.BREAK_PRICE);
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
    if (data.exitTactics.POSITION_BREAK_PRICE !== undefined) {
      const [valid, msg] = positionBreakPriceValidation(
        data.exitTactics.POSITION_BREAK_PRICE
      );
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
    if (data.exitTactics.GRAB_CENTS !== undefined) {
      const [valid, msg] = grabCentsValidation(data.exitTactics.GRAB_CENTS);
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
    if (data.exitTactics.RATCHET_BRACKET !== undefined) {
      const [valid, msg] = ratchetBracketValidation(
        data.exitTactics.RATCHET_BRACKET
      );
      if (!valid) {
        validForm = false;
        message += msg;
      }
    }
  }
  const gcUsed = data.exitTactics.GRAB_CENTS !== undefined;
  const rbUsed = data.exitTactics.RATCHET_BRACKET !== undefined;
  const cmUsed = data.exitTactics.CANDLE_MAGNITUDE !== undefined;

  let restingExitCount = 0;
  if (gcUsed) {
    restingExitCount++;
  }
  if (rbUsed) {
    restingExitCount++;
  }
  if (cmUsed) {
    restingExitCount++;
  }
  if (restingExitCount > 1) {
    validForm = false;
    message +=
      ' choose either grab cents, candleMagnitude, or ratchet bracket, but not both. ';
  }

  if (data.positionTactics !== undefined) {
    if (data.positionTactics.SCALING_IN !== undefined) {
      if (
        data.positionTactics.SCALING_IN.breakPrices === undefined ||
        data.positionTactics.SCALING_IN.breakPrices === null
      ) {
        validForm = false;
        message += ' No scalingIn break prices. ';
      }
      if (data.positionTactics.SCALING_IN.quantityBasisValues === undefined) {
        validForm = false;
        message += ' No scalingIn quantity basis values. ';
      }
      if (
        data.positionTactics.SCALING_IN.breakPrices !== undefined &&
        data.positionTactics.SCALING_IN.quantityBasisValues !== undefined
      ) {
        if (
          data.positionTactics.SCALING_IN.breakPrices.length !==
          data.positionTactics.SCALING_IN.quantityBasisValues.length
        ) {
          validForm = false;
          message +=
            ' scalingIn quantity basis values and break prices are not equal. ';
        }
      }
    }
    if (data.positionTactics.ADD_TO_WINNER !== undefined) {
      if (
        data.positionTactics.ADD_TO_WINNER.breakPrices === undefined ||
        data.positionTactics.ADD_TO_WINNER.breakPrices == null
      ) {
        validForm = false;
        message += ' No addToWinner break prices. ';
      }
      if (
        data.positionTactics.ADD_TO_WINNER.quantityBasisValues === undefined ||
        data.positionTactics.ADD_TO_WINNER.quantityBasisValues === null
      ) {
        validForm = false;
        message += ' No addToWinner quantity basis values. ';
      }
      if (
        data.positionTactics.ADD_TO_WINNER.breakPrices !== undefined &&
        data.positionTactics.ADD_TO_WINNER.quantityBasisValues !== undefined
      ) {
        if (
          data.positionTactics.ADD_TO_WINNER.breakPrices.length !==
          data.positionTactics.ADD_TO_WINNER.quantityBasisValues.length
        ) {
          validForm = false;
          message +=
            ' addToWinner quantity basis values and break prices are not equal. ';
        }
      }
    }
  }
  if (
    data.brokerage === 'none' ||
    data.brokerage === '' ||
    data.brokerage === undefined
  ) {
    validForm = false;
    message += 'No brokerage. ';
  }
  if (data.brokerage !== 'BACKTEST' && data.accountNumber === 'BACKTEST') {
    validForm = false;
    message += 'Sim account # selected for non-sim brokerage';
  }
  if (
    data.accountNumber === 'none' ||
    data.accountNumber === '' ||
    data.accountNumber === undefined
  ) {
    console.log('no account num');
    validForm = false;
    message += 'No accountNumber. ';
  }
  if (data.quantityBasis !== 'DOLLARS' && data.quantityBasis !== 'QUANTITY') {
    validForm = false;
    message += 'No QuantityBasis. ';
  }
  if (data.instrument === 'none') {
    validForm = false;
    message += 'No instrument. ';
  }
  if (data.setup === 'none') {
    validForm = false;
    message += 'No setup. ';
  }
  if (data.setup === 'BOUNCE') {
    if (parseFloat(data.setupDetails.BOUNCE.priceToBreak) === 0) {
      validForm = false;
      message += 'bounce price to break is zero. ';
    }
  }
  if (data.setup === 'BREAK') {
    console.log(data.setupDetails);
    if (parseFloat(data.setupDetails.BREAK.priceToBreak) === 0) {
      validForm = false;
      message += 'break price to break is zero. ';
    }
    if (data.entryTactics.CANDLE_BREAK !== undefined) {
      if (!data.entryTactics.CANDLE_BREAK.waitUntilCurrentCandleCloses) {
        validForm = false;
        message += 'dont wait until current candle closes on break setup. ';
      }
    }
  }
  if (data.setup === 'CANDLE_TRIGGER') {
    if (data.entryTactics.CANDLE_BREAK !== undefined) {
      if (!data.entryTactics.CANDLE_BREAK.waitUntilCurrentCandleCloses) {
        validForm = false;
        message += 'dont wait until current candle closes on break setup. ';
      }
    }
  }

  if (data.setup === 'CONVICTION_CANDLE') {
    if (parseInt(data.setupDetails.CONVICTION_CANDLE.candleDuration) === 0) {
      validForm = false;
      message += 'conviction candle candle duration is zero. ';
    }
  }
  if (data.setup === 'FTFC') {
    if (data.entryTactics.CANDLE_BREAK !== undefined) {
      if (!data.entryTactics.CANDLE_BREAK.waitUntilCurrentCandleCloses) {
        validForm = false;
        message += 'dont wait until current candle closes on FTFC setup. ';
      }
    }
    if (data.setupDetails.FTFC.timeFrames.length === 0) {
      validForm = false;
      message += 'no supplied time frames. ';
    } else {
      for (const i in data.setupDetails.FTFC.timeFrames) {
        const tf = data.setupDetails.FTFC.timeFrames[i];
        if (parseInt(tf.candleDuration) === 0) {
          validForm = false;
          message += 'time frame cannot have a candleDuration of 0.';
        }
        if (tf.timeUnit === undefined || tf.timeUnit === '') {
          validForm = false;
          message += 'time frame time unit not supplied.';
        }
      }
    }
  }
  if (data.setup === 'BOUNCE_EMA') {
    if (parseInt(data.setupDetails.BOUNCE_EMA.candleDuration) === 0) {
      validForm = false;
      message += 'bounce ema candle duration is zero. ';
    }
    if (
      data.setupDetails.BOUNCE_EMA.periodLengths === undefined ||
      data.setupDetails.BOUNCE_EMA.periodLengths === null ||
      data.setupDetails.BOUNCE_EMA.periodLengths.length === 0
    ) {
      validForm = false;
      message += 'bounce ema period Length is zero. ';
    }
  }
  if (data.setup === 'BREAK_CANDLE_TYPE') {
    if (parseInt(data.setupDetails.BREAK_CANDLE_TYPE.candleDuration) === 0) {
      validForm = false;
      message += 'break candle type candle duration is zero. ';
    }
    if (
      data.setupDetails.BREAK_CANDLE_TYPE.candleType === '' ||
      data.setupDetails.BREAK_CANDLE_TYPE.candleType === undefined
    ) {
      validForm = false;
      message += 'break candle type candle type is empty. ';
    }
    if (
      data.setupDetails.BREAK_CANDLE_TYPE.candleColor === '' ||
      data.setupDetails.BREAK_CANDLE_TYPE.candleColor === undefined
    ) {
      validForm = false;
      message += 'break candle type candle color is empty. ';
    }
  }
  if (data.setup === 'BREAK_EMA') {
    if (parseInt(data.setupDetails.BREAK_EMA.candleDuration) === 0) {
      validForm = false;
      message += 'break ema candle duration is zero. ';
    }
    if (
      data.setupDetails.BREAK_EMA.periodLengths === undefined ||
      data.setupDetails.BREAK_EMA.periodLengths == null ||
      data.setupDetails.BREAK_EMA.periodLengths.length === 0
    ) {
      validForm = false;
      message += 'break ema period Length is zero. ';
    }
    if (data.entryTactics.CANDLE_BREAK !== undefined) {
      if (data.entryTactics.CANDLE_BREAK.waitUntilCurrentCandleCloses) {
        validForm = false;
        message += 'dont wait until current candle closes on break setup. ';
      }
    }
  }

  if (data.instrument === 'option') {
    if (data.optionManagement === undefined) {
      validForm = false;
      message += 'instrument == option, but no option management. ';
    }
  }

  if (data.optionManagement !== undefined) {
    if (data.optionManagement.optionFilters !== undefined) {
      if (
        data.optionManagement.optionFilters.maxOptionSpreadPct !== undefined
      ) {
        if (
          parseFloat(
            data.optionManagement.optionFilters.tightSpreadPct
              .maxOptionSpreadPct
          ) === 0
        ) {
          validForm = false;
          message += 'max spread pct is zero. ';
        }
      }
      if (data.optionManagement.optionFilters.tightSpreadCents !== undefined) {
        if (
          parseFloat(
            data.optionManagement.optionFilters.tightSpreadCents
              .maxOptionSpreadCents
          ) === 0
        ) {
          validForm = false;
          message += 'max spread cents is zero. ';
        }
      }
    }
    if (
      data.optionManagement.expirationDates === null ||
      data.optionManagement.expirationDates === undefined ||
      data.optionManagement.expirationDates.length === 0
    ) {
      validForm = false;
      message += 'No expirationDates. ';
    }
    const oc = data.optionManagement.optionChoices.choices;
    if (oc === undefined || isEmpty(oc)) {
      validForm = false;
      message += 'No options chosen. ';
    }
    let containsPuts = false;
    let containsCalls = false;

    for (const date in oc) {
      const chain = oc[date];
      for (const num in chain) {
        const option = chain[num];
        //first lets make sure that no symbol is incorrect...
        let underlying;
        let index = 0;
        for (const i in option) {
          const char = option[i];
          if (!(!isNaN(parseFloat(char)) && isFinite(char))) {
            //ie is a character
            index++;
          } else {
            underlying = option.substring(0, index);
            break;
          }
        }
        if (underlying.toLowerCase() !== data.symbol.toLowerCase()) {
          validForm = false;
          message +=
            'We have encountered an issue and found an option symbol(' +
            option +
            ') that does not match up to the underlying (' +
            data.symbol +
            ') ' +
            'for this trade plan. Please change the symbol and then change back, and make sure the correct options are selected ';
          break;
        }
        if (option.substring(7).includes('P')) {
          containsPuts = true;
        } else if (option.substring(7).includes('C')) {
          containsCalls = true;
        }
      }
    }

    if (data.goLong && !data.goShort) {
      if (data.optionManagement.buyOrSellOption === 'LONG') {
        //if contains any puts, invalid
        if (!containsCalls) {
          message += 'trade plan goLong + buying options has no calls. ';
          validForm = false;
        }
      }
      if (data.optionManagement.buyOrSellOption === 'SHORT') {
        //if contains any calls, invalid
        if (!containsPuts) {
          message += 'trade plan goLong + selling options has no puts. ';
          validForm = false;
        }
      }
    }
    if (!data.goLong && data.goShort) {
      if (data.optionManagement.buyOrSellOption === 'LONG') {
        //if contains any calls, invalid
        if (!containsPuts) {
          message += 'trade plan goShort + buying options has no puts. ';
          validForm = false;
        }
      }
      if (data.optionManagement.buyOrSellOption === 'SHORT') {
        //if contains any puts, invalid
        if (!containsCalls) {
          message += 'trade plan goShort + selling options has no calls. ';
          validForm = false;
        }
      }
    }
  }
  if (data.setupFilters !== undefined) {
    if (data.setupFilters.TIME_OF_DAY) {
      const tod = data.setupFilters.TIME_OF_DAY;
      if (tod.startHour > 24) {
        validForm = false;
        message += 'Time of Day field: start hour is greater than 24 ';
      }
      if (tod.startMinute > 60) {
        validForm = false;
        message += 'Time of Day field: start min is greater than 60 ';
      }
      if (tod.endHour > 24) {
        validForm = false;
        message += 'Time of Day field: end hour is greater than 24 ';
      }
      if (tod.endMinute > 60) {
        validForm = false;
        message += 'Time of Day field: end min is greater than 60 ';
      }
    }
    if (data.setupFilters.PRICE_INTERSECTS_FIRST_CANDLE !== undefined) {
      if (
        parseInt(
          data.setupFilters.PRICE_INTERSECTS_FIRST_CANDLE.candleDuration
        ) === 0
      ) {
        validForm = false;
        message += 'price intersects first candle candle duration is zero. ';
      }
      if (data.goLong === data.goShort) {
        validForm = false;
        message +=
          "price intersects first candle candle can't be long and short. ";
      }
      if (
        data.setupFilters.PRICE_INTERSECTS_FIRST_CANDLE.candleBarrier === '' ||
        data.setupFilters.PRICE_INTERSECTS_FIRST_CANDLE.direction === ''
      ) {
        validForm = false;
        message +=
          'price intersects first candle candle high/low/above/below not selected';
      }
    } else if (data.setupFilters.EMA_INTERSECTS_FIRST_CANDLE !== undefined) {
      if (data.goLong === data.goShort) {
        validForm = false;
        message +=
          "ema intersects first candle candle can't be long and short. ";
      }
      if (
        data.setupFilters.EMA_INTERSECTS_FIRST_CANDLE.candleBarrier === '' ||
        data.setupFilters.EMA_INTERSECTS_FIRST_CANDLE.direction === ''
      ) {
        validForm = false;
        message +=
          'price intersects first candle candle high/low/above/below not selected';
      }
    } else if (data.setupFilters.FTFC !== undefined) {
      if (data.setupFilters.FTFC.timeFrames.length === 0) {
        validForm = false;
        message += 'no supplied time frames. ';
      } else {
        for (const i in data.setupFilters.FTFC.timeFrames) {
          const tf = data.setupFilters.FTFC.timeFrames[i];
          if (parseInt(tf.candleDuration) === 0) {
            validForm = false;
            message += 'time frame cannot have a candleDuration of 0.';
          }
          if (tf.timeUnit === undefined || tf.timeUnit === '') {
            validForm = false;
            message += 'time frame time unit not supplied.';
          }
        }
      }
    }
  }
  return [validForm, message];
};
